// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // api_url: 'http://192.168.3.31:3010'
  // api_url: 'http://192.168.100.27:3010'
  // api_url: 'https://khapatientregistry.westeurope.cloudapp.azure.com'
  // api_url:"http://57.154.208.251:5000"
  api_url: 'https://registry-v1.haemophilia-kenya.org:5000',
};
